// ファイル取込 UI（ドロップゾーン）。
//
// 役割: GeoJSON / FlatGeobuf / GeoParquet を選択またはドロップで受け取り、onFiles に渡す。
// 関係: レイヤータブの先頭に置く。onFiles は App 側で取込パイプライン（layer-service.importFile）へ。
//
// 流用元: reference/deckgl-duckdb-template/src/components/FileUpload.jsx
import { useRef, useState } from 'react'

function FileUpload({
  onFiles,
  busy,
  accept = '.geojson,.json,.fgb,.parquet,.csv',
  hint = '.geojson / .json / .fgb / .parquet / .csv',
}) {
  const inputRef = useRef(null)
  const [dragOver, setDragOver] = useState(false)

  const handleChange = (e) => {
    const files = Array.from(e.target.files ?? [])
    if (files.length) onFiles(files)
    e.target.value = '' // 同じファイルを再選択できるようリセット
  }

  const handleDrop = (e) => {
    e.preventDefault()
    setDragOver(false)
    const files = Array.from(e.dataTransfer.files ?? [])
    if (files.length) onFiles(files)
  }

  return (
    <div className="file-upload">
      <div
        className={`dropzone${dragOver ? ' dragover' : ''}`}
        onClick={() => inputRef.current?.click()}
        onDragOver={(e) => {
          e.preventDefault()
          setDragOver(true)
        }}
        onDragLeave={() => setDragOver(false)}
        onDrop={handleDrop}
      >
        {busy ? '読み込み中…' : 'クリックまたはドロップで取込'}
        <div className="hint">{hint}</div>
      </div>
      <input
        ref={inputRef}
        type="file"
        accept={accept}
        multiple
        style={{ display: 'none' }}
        onChange={handleChange}
      />
    </div>
  )
}

export default FileUpload
